import React, { PureComponent } from 'react'
import { Col } from 'reactstrap'
import ProductItems from './ProductItems'
import videoItemList from './catalog_list'

class CatalogItems extends PureComponent {
  render () {
    return (
      <Col md={12} lg={12}>
        <ProductItems items={videoItemList} active={this.props.active}/>
      </Col>
    )
  }
}

export default CatalogItems



// WEBPACK FOOTER //
// ./src/components/training/components/CatalogItems.js